import React, { useState } from 'react';
import "./Music.css";
import Navbar from "../components/Navbar";
import FooterAction from '../components/FooterAction';

const releases = [
  { id: 1, title: "Shit Like That 2 (feat. Nino Man) [Remix]", date: "17 May 2026", type: "Single", image: "/images/music/shitlikethat2.jpg", spotify: "https://open.spotify.com/album/76OzwW6TcpnIQyGDbLuy9X", deezer: "https://www.deezer.com/album/987469521" },
  { id: 2, title: "Controversy", date: "2025", type: "Single", image: "/images/music/cartoon.jpg", spotify: "https://open.spotify.com/track/4qRQckqiKpxZhnEevou8EY", deezer: "https://www.deezer.com/en/album/826427071" },
  { id: 3, title: "Came 2 Win (feat. Scorch)", date: "2025", type: "Single", image: "/images/music/came2win.jpg", spotify: "https://open.spotify.com/album/5k5TQYp7xDTH5cKE8Kdiom", deezer: "https://www.deezer.com/en/album/800687241" },
  { id: 4, title: "Go Time", date: "2025", type: "Single", image: "/images/music/gotime.jpg", spotify: "https://open.spotify.com/album/0nPi5y8gaOC0Poqrp574oC", deezer: "https://www.deezer.com/en/album/790545791" },
  { id: 5, title: "Lift You Up (Radio Edit)", date: "2025", type: "Single", image: "/images/music/liftyouup.jpg", spotify: "https://open.spotify.com/album/7gAYQDw0lLy9E1QEjpDP39", deezer: "https://www.deezer.com/en/album/791170281" },
  { id: 6, title: "Poolside", date: "2025", type: "Single", image: "/images/music/poolside.jpg", spotify: "https://open.spotify.com/artist/69CmS1z7XlPgstN0L95gdK", deezer: "https://www.deezer.com/artist/14516792" },
  { id: 7, title: "The Real Deal", date: "2025", type: "Single", image: "/images/music/realdeal.jpg", spotify: "https://open.spotify.com/album/02wKAsTwHgtwNxdL1rkFhy", deezer: "https://www.deezer.com/en/album/778409141" },
  { id: 8, title: "Blowing Up", date: "2025", type: "Single", image: "/images/music/bowlingup.jpg", spotify: "https://open.spotify.com/album/5tq0v1OWO7dCR8AguO8PyW", deezer: "https://www.deezer.com/en/album/760637771" },
  { id: 9, title: "Downtown Allstars (feat. Llegend)", date: "25 Apr 2025", type: "Single", image: "/images/music/downtown.jpg", spotify: "https://open.spotify.com/album/3qnEHeRyD73JIs6o8DTvHm", deezer: "https://www.deezer.com/en/album/748009721" },
  { id: 10, title: "Lift You Up", date: "2024", type: "Single", image: "/images/music/liftyouup.jpg", spotify: "", deezer: "https://www.deezer.com/en/album/709059471" },
  { id: 11, title: "State 2 State (feat. Bc, Scorch & Glitzy)", date: "2024", type: "Single", image: "/images/music/state2state.jpg", spotify: "", deezer: "https://www.deezer.com/en/album/692493251" },
  { id: 12, title: "GO DUMMY (feat. Tori Doe & Llegend)", date: "2024", type: "Single", image: "/images/music/godummy.jpg", spotify: "", deezer: "https://www.deezer.com/en/album/687156111" },
];


export default function Music() {
  const [selected, setSelected] = useState(null);

  return (
    <div className="music-page">
      {/* blurred bg from selected or default dark */}
      <div
        className="music-background"
        style={selected ? { backgroundImage: `url(${selected.image})` } : {}}
      />

      <Navbar />

      {/* ── Detail view ── */}
      {selected ? (
        <div className="music-detail">
          {/* back button */}
          <button className="detail-back" onClick={() => setSelected(null)}>
            ← Back
          </button>

          <div className="detail-card">
            {/* cover image */}
            <img src={selected.image} alt={selected.title} className="detail-cover" />

            {/* title + meta */}
            <div className="detail-meta">
              <p className="detail-title">{selected.title}</p>
              <p className="detail-sub">{selected.type} • {selected.date}</p>
            </div>

            {/* listen section */}
            {/* <div className="detail-listen">
              <p className="detail-listen-label">Listen</p>
              <a href={selected.spotify} target="_blank" rel="noopener noreferrer" className="detail-stream-btn">
                <span className="stream-btn-left"><SpotifyIcon /> Spotify</span>
                <ArrowIcon />
              </a>
              <div className="detail-divider" />
              <a href={selected.deezer} target="_blank" rel="noopener noreferrer" className="detail-stream-btn">
                <span className="stream-btn-left"><DeezerIcon /> Deezer</span>
                <ArrowIcon />
              </a>
            </div> */}
            <div className="detail-listen">
              <p className="detail-listen-label">Listen</p>

              {selected.spotify && (
                <>
                  <a
                    href={selected.spotify}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="detail-stream-btn"
                  >
                    <span className="stream-btn-left">
                      <SpotifyIcon />
                      Spotify
                    </span>
                    <ArrowIcon />
                  </a>

                  {selected.deezer && (
                    <div className="detail-divider" />
                  )}
                </>
              )}

              {selected.deezer && (
                <a
                  href={selected.deezer}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="detail-stream-btn"
                >
                  <span className="stream-btn-left">
                    <DeezerIcon />
                    Deezer
                  </span>
                  <ArrowIcon />
                </a>
              )}
            </div>
          </div>
        </div>
      ) : (
        /* ── Grid view ── */
        <div className="music-container">
          {releases.map((release) => (
            <div
              key={release.id}
              className="release-card"
              onClick={() => setSelected(release)}
            >
              <img src={release.image} alt={release.title} className="release-image" />
            </div>
          ))}
        </div>

        
      )}

      <FooterAction/>
    </div>

    
  );
}
function SpotifyIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
    </svg>
  );
}
 
function DeezerIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
      <path d="M18.944 16.667h3.223v1.111h-3.223zm-4.61 0h3.222v1.111h-3.222zm-4.611 0h3.222v1.111H9.723zm-4.61 0h3.221v1.111H5.113zM14.334 14.444h3.222v1.111h-3.222zm-4.611 0h3.222v1.111H9.723zm-4.61 0h3.221v1.111H5.113zm13.831-2.222h3.223v1.111h-3.223zm-4.61 0h3.222v1.111h-3.222zm-4.611 0h3.222v1.111H9.723zm-4.61 0h3.221v1.111H5.113zM18.944 9.999h3.223v1.111h-3.223zm-4.61 0h3.222v1.111h-3.222zm-4.611 0h3.222v1.111H9.723zm9.221-2.221h3.223v1.111h-3.223zm-4.61 0h3.222v1.111h-3.222zm4.61-2.223h3.223v1.111h-3.223z"/>
    </svg>
  );
}

function ArrowIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="7" y1="17" x2="17" y2="7"/>
      <polyline points="7,7 17,7 17,17"/>
    </svg>
  );
}







// import "./Music.css";
// import Navbar from "../components/Navbar";

// const releases = [
//   {
//     id: 1,
//     title: "Shit Like That 2 Remix",
//     image: "/images/music/shitlikethat2.jpg",
//     slug: "shit-like-that-2-remix",
//   },
//   {
//     id: 2,
//     title: "Cartoon Cover",
//     image: "/images/music/cartoon.jpg",
//     slug: "cartoon-cover",
//   },
//   {
//     id: 3,
//     title: "Came 2 Win",
//     image: "/images/music/came2win.jpg",
//     slug: "came-2-win",
//   },
//   {
//     id: 4,
//     title: "Go Time",
//     image: "/images/music/gotime.jpg",
//     slug: "go-time",
//   },  
//   {
//     id: 5,
//     title: "Lift You Up ",
//     image: "/images/music/liftyouup.jpg",
//     slug: "poolside",
//   },
//     {
//     id: 6,
//     title: "Poolside",
//     image: "/images/music/poolside.jpg",
//     slug: "poolside",
//   },
//     {
//     id: 7,
//     title: "The Real Deal",
//     image: "/images/music/realdeal.jpg",
//     slug: "realdeal",
//   },
//     {
//     id: 8,
//     title: "Blowing Up",
//     image: "/images/music/blowingup.jpg",
//     slug: "blowingUp",
//   },
//   {
//     id: 9,
//     title: "Downtown",
//     image: "/images/music/downtown.jpg",
//     slug: "Downtown Allstars (feat. Llegend)",
//   },
//   {
//     id: 10,
//     title: "Downtown",
//     image: "/images/music/downtown.jpg",
//     slug: "Downtown Allstars (feat. Llegend)",
//   },
//   {
//     id: 11,
//     title: "State 2 state (feat. Bc, Scorch & Glitzy)",
//     image: "/images/music/state2state.jpg",
//     slug: "state-2-state",
//   },
//   {
//     id: 12,
//     title: "GO DUMMY (feat. Tori doe & Llegend)",
//     image: "/images/music/godummy.jpg",
//     slug: "go-dummy",
//   },

// ];

// function Music() {
//   return (
//     <div className="music-page">

//       <div className="music-background"></div>

//       <Navbar />

//       <div className="music-container">

//         {releases.map((release) => (
//           <div
//             key={release.id}
//             className="release-card"
//           >
//             <img
//               src={release.image}
//               alt={release.title}
//               className="release-image"
//             />
//           </div>
//         ))}

//       </div>

//     </div>
//   );
// }

// export default Music;